<script lang="ts">
	import type { CrumbItem } from './breadcrumbs';
	import ChevronRight from '$lib/assets/images/icons/chevron-right.svg?component';
	import { page } from '$app/stores';

	let className = '';

	export { className as class };
	export let crumbs: CrumbItem[] = [];
	export let arrowClass: string | null = null;

	let crumbsCount = 0;
	$: crumbsCount = crumbs.length;
</script>

<nav class={className}>
	<ul class="flex flex-wrap items-center gap-x-2 gap-y-4 font-bold uppercase sm:gap-x-4">
		{#each crumbs as crumbItem, index}
			<li class={crumbItem.class || 'flex items-center gap-x-2 sm:gap-x-4'}>
				{#if index > 0}
					<ChevronRight class={arrowClass || 'h-3 w-4 stroke-white stroke-[10px]'} />
				{/if}
				{#if crumbItem.url}
					<a
						data-sveltekit-preload-data="off"
						class="hover:underline"
						href={$page.data?.location?.origin + crumbItem.url}>{crumbItem.label}</a
					>
				{:else}
					<p>{crumbItem.label}</p>
				{/if}
			</li>
		{/each}
	</ul>
</nav>
